import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var DeviceTypeContext = /*#__PURE__*/createContext(undefined);
export var DeviceTypeProvider = function DeviceTypeProvider(_ref) {
  var deviceType = _ref.deviceType,
      children = _ref.children;
  return /*#__PURE__*/_jsx(DeviceTypeContext.Provider, {
    value: deviceType,
    "data-element": "unknown",
    "data-component": "DeviceTypeProvider",
    "data-source-file": "use-device-type.tsx",
    children: children
  });
};
export var useDeviceType = function useDeviceType() {
  return useContext(DeviceTypeContext);
};